import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ProjectsService } from '../../../../../core/projects.service';
import { AuthService } from '../../../../../../../shared/services';
import { takeUntil } from 'rxjs/operators';
import * as fromRoot from '../../../../../../../state/app.state';
import { projectDetails } from '../../../../../core/projects.selectors';

@Component({
    selector: 'app-change-order-tab-wrapper',
    templateUrl: './change-order-tab-wrapper.component.html',
    styleUrls: ['./change-order-tab-wrapper.component.scss'],
    standalone: false
})
export class ChangeOrderTabWrapperComponent implements OnInit, OnDestroy {
  allHeaders: any[] = [
    {
      id: 2,
      label: 'Change in work request',
      qp: 'ciwr',
      mode: 'workflow',
    },
    {
      id: 1,
      label: 'Change orders',
      qp: 'cor',
      mode: 'workflow',
    },
    {
      id: 0,
      label: 'Bid sheet',
      qp: 'change-orders',
    },
  ];
  headersList: any[] = [];
  selectedTabId = 0;
  selectedTabLabel: any;
  projectId: any;
  account: any;
  role: any;
  changeOrderMode: string;
  isContractorMode: boolean;
  displayActivityCodes: boolean;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<fromRoot.State>,
    private projectsService: ProjectsService,
    private authService: AuthService,
  ) {
  }

  ngOnInit() {
    this.store.select(projectDetails)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(project => {
        if (project && Object.keys(project).length) {
          this.changeOrderMode = project?.source_entity_extra_attributes?.change_order_mode || 'direct';
          this.applyTabFilters();
        }
      });

    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        if (qp.fs === undefined) {
          if (qp?.subTab) {
            this.selectedTabId = this.headersList.find(o => o?.qp === qp?.subTab)?.id ?? 0;
            if (this.headersList.find(o => o?.qp === qp?.subTab)?.id >= 4) {
              this.selectedTabLabel = this.headersList.find(o => o?.qp === qp?.subTab)?.label;
            }
          }
        }
      });

    this.route.params
      .pipe(takeUntil(this.onDestroy))
      .subscribe(p => {
        if (p.projectId) {
          this.projectId = p.projectId;

          this.account = this.authService.getCurrentUser();
          this.role = this.account.roles.find(obj => obj.project_id === this.projectId)?.role;

          this.applyTabFilters();
        }
      });
  }

  private applyTabFilters() {
    if (!this.changeOrderMode) return;

    if (this.changeOrderMode === 'direct') {
      // Direct mode: only show Bid sheet
      this.headersList = this.allHeaders.filter(h => !h.mode);
    } else {
      // Workflow mode: show all tabs
      this.headersList = [...this.allHeaders];
    }

    if (!!this.role?.includes('reviewer')) {
      this.headersList = this.headersList.filter(obj =>
        ['Log'].includes(obj.label),
      );
    }

    // Set default tab if current selection is not in the filtered list
    if (!this.headersList.find(h => h.id === this.selectedTabId)) {
      const defaultTab = this.headersList[0];
      if (defaultTab) {
        this.selectedTabId = defaultTab.id;
        this.router.navigate([], {
          queryParams: { subTab: defaultTab.qp },
          queryParamsHandling: 'merge',
        });
      }
    }
  }

  selectHeader(header) {
    this.projectsService.closeRightPanel.next();
    this.selectedTabId = header.id;
    this.selectedTabLabel = null;

    this.router.navigate([], {
      queryParams: {
        subTab: header.qp,
      },
      queryParamsHandling: 'merge',
    });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
